import React from 'react'
import HeroSection from './HeroSection'
import About from './About';
import Services from './Services';
import TechIcons from './TechIcons';
import WorkCategory from './WorkCategory';
function App() {
  return (
    <div className='tracking-widest'>
      <HeroSection/>
      <About/>
      <Services/>
      <TechIcons/>
      <WorkCategory/>
    </div>
  )
}

export default App
